<template>
  <v-card id="create">
    <v-speed-dial
      v-model="fab"
      :top="top"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          :style="{ background: background ?? 'gold' }"
          dark
          fab
        >
          <v-icon>mdi-share-variant-outline</v-icon>
        </v-btn>
      </template>
      <div style="overflow-y: scroll; max-height: 200px">
        <v-btn
          @click="goToUrl(item.url, item.pattern)"
          :style="{ background: background ?? 'gold' }"
          fab
          small
          v-for="(item, i) in computeFields"
          :key="i"
        >
          <img :src="item.img" alt="" class="img-fluid" 
             :height="['svgDigikala',
                            'svgBasalam',
                            'svgSnappshop',
                            'svgTechnolife',
                            'svgTorob',
                            'svgEmalls',].includes(item.svg)?'55px':'35px'" :width="['svgDigikala',
                            'svgBasalam',
                            'svgSnappshop',
                            'svgTechnolife',
                            'svgTorob',
                            'svgEmalls',].includes(item.svg)?'55px':'35px'"/>
        </v-btn>
      </div>
    </v-speed-dial>
  </v-card>
</template>

<script>
export default {
  name: "floatingBtnGold",

  props: {
    value: {},
    background: String,
    color: String,
  },

  data: () => ({
    direction: "top",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: false,
    left: false,
    transition: "slide-y-reverse-transition",
  }),

  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value).forEach(([x, y]) => {
        extra.push(...y);
      });

      return extra;
    },
  },

  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },

  methods: {
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
  },
};
</script>

<style scoped>
#create .v-speed-dial {
  position: absolute;
  z-index: 10;
}

#create .v-btn--floating {
  position: relative;
}
</style>
